import React from "react";
import StepNavigation from "./StepNavigation";
import { useTranslation } from "react-i18next";
import "../../styles/steps.css";

export default function StepRooms({
  listing,
  setListing,
  onBack,
  onNext,
}) {
  const { t } = useTranslation();

  if (listing.type === "land") return null;

  const FLOOR_ALLOWED_TYPES = ["apartment", "hotel", "commercial_space"];
  const FLOOR_COUNT_TYPES = ["house", "country_house"];

  const allowsFloor = FLOOR_ALLOWED_TYPES.includes(listing.type);
  const allowsFloorCount = FLOOR_COUNT_TYPES.includes(listing.type);

const requiresBedrooms = listing.type !== "commercial_space";

const requiresBathrooms = listing.type !== "commercial_space";

const ROOM_OPTIONS = [
  "1","2","3","4","5","6","7","8","9","10","10+"
];

  const isNextDisabled =
  listing.rooms == null || listing.rooms === "" ||

  (requiresBedrooms &&
    (listing.bedrooms == null || listing.bedrooms === "")) ||

  (requiresBathrooms &&
    (listing.bathrooms == null || listing.bathrooms === "")) ||

  (allowsFloor &&
    (listing.floor == null || listing.totalFloors == null)) ||

  (allowsFloorCount && listing.totalFloors == null);

  return (
    <div className="step">
      <h2 className="step-title">{t("rooms_floors")}</h2>

      <div className="form-grid">
        {/* ROOMS */}
        <div className="form-group">
  <label className="form-label">
    {t("rom.rooms")}<span className="required">*</span>
  </label>

  <select
    className="form-input"
    value={listing.rooms ?? ""}
    onChange={(e) =>
  setListing((l) => ({
    ...l,
    rooms: e.target.value, // "1"..."10","10+"
  }))
}
  >
    <option value="">{t("select")}</option>

    {ROOM_OPTIONS.map((r) => (
      <option key={r} value={r}>
        {r}
      </option>
    ))}
  </select>
</div>

        {/* BEDROOMS */}
        <div className="form-group">
          <label className="form-label">{t("bed.bedrooms")}
{requiresBedrooms && <span className="required">*</span>}</label>
         <select
  className="form-input"
  value={listing.bedrooms ?? ""}
  onChange={(e) =>
    setListing((l) => ({
      ...l,
      bedrooms: e.target.value,
    }))
  }
>
  <option value="">{t("select")}</option>

  {ROOM_OPTIONS.map((r) => (
    <option key={r} value={r}>
      {r}
    </option>
    ))}
  </select>
      </div>

{/* BATHROOMS */}
<div className="form-group">
  <label className="form-label">
    {t("bath.bathrooms")}
{requiresBathrooms && <span className="required">*</span>}
  </label>
  <select
  className="form-input"
  value={listing.bathrooms ?? ""}
  onChange={(e) =>
    setListing((l) => ({
      ...l,
      bathrooms: e.target.value,
    }))
  }
>
  <option value="">{t("select")}</option>

  {ROOM_OPTIONS.map((r) => (
    <option key={r} value={r}>
      {r}
    </option>
  ))}
</select>
</div>



{/* TOTAL FLOORS FOR HOUSES */}
{allowsFloorCount && (
  <div className="form-group">
    <label className="form-label">
      {t("flo.totalFloors")}<span className="required">*</span>
    </label>

    <input
      type="number"
      min="1"
      className="form-input"
      value={listing.totalFloors ?? ""}
      onChange={(e) =>
        setListing((l) => ({
          ...l,
          totalFloors:
            e.target.value === ""
              ? null
              : Number(e.target.value),
        }))
      }
    />
  </div>
)}

        {/* FLOOR */}
{allowsFloor && (
  <>
    <div className="form-group">
      <label className="form-label">
        {t("flo.totalFloors")}<span className="required">*</span>
      </label>

      <input
        type="number"
        min="1"
        className="form-input"
        value={listing.totalFloors ?? ""}
        onChange={(e) =>
          setListing((l) => ({
            ...l,
            totalFloors:
              e.target.value === ""
                ? null
                : Number(e.target.value),
          }))
        }
      />
    </div>

    <div className="form-group">
      <label className="form-label">
        {t("flo.floor")}<span className="required">*</span>
      </label>

      <input
        type="number"
        min="0"
        className="form-input"
        value={listing.floor ?? ""}
        onChange={(e) =>
          setListing((l) => ({
            ...l,
            floor:
              e.target.value === ""
                ? null
                : Number(e.target.value),
          }))
        }
      />
    </div>
   </>
  )}
</div>

      <StepNavigation
        onBack={onBack}
        onNext={onNext}
        nextDisabled={isNextDisabled}
      />
    </div>
  );
}
